import { results as results1 } from './pathway-1';
import { results as results2 } from './pathway-2';
import { results as results3 } from './pathway-3';
import { results as results5 } from './pathway-5';
import { results as results6 } from './pathway-6';
import { results as results7 } from './pathway-7';

const results = [
    ...results1,
    ...results2,
    ...results3,
    ...results5,
    ...results6,
    ...results7
]

export default results;
